import ContentLoader from "react-content-loader";
import { apiDomain } from "../../js/server";

function List(props) {
  const setList = () => {
    switch (props.id) {
      case "MemberList": //관리자 회원관리
        return (
          <table className="table table-hover text-nowrap custom-table">
            <thead>
              <tr>
                <th>업체명</th>
                <th>대표자명</th>
                <th>사업자등록번호</th>
                <th className="text-center">가입여부</th>
                <th>가입아이디</th>
                <th>등록일자</th>
              </tr>
            </thead>
            <tbody>
              {props.posts.length > 0 ? (
                props.posts.map((post, i) => {
                  return (
                    <tr
                      key={post.comcode}
                      onClick={() => {
                        props.listClick(post.comcode);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <td>{post.comname}</td>
                      <td>{post.boss}</td>
                      <td>{post.comidno}</td>
                      <td className="text-center">{post.userid ? "O" : "X"}</td>
                      <td>{post.userid}</td>
                      <td>{post.registday.slice(0, 10)}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="6">결과가 없습니다.</td>
                </tr>
              )}
            </tbody>
          </table>
        );
      case "Info": //일반 게시판
        return (
          <table className="table table-hover text-nowrap custom-table">
            <thead>
              <tr>
                <th>번호</th>
                <th>제목</th>
                <th className="text-center">첨부</th>
                <th className="text-right">조회수</th>
                <th>작성일</th>
              </tr>
            </thead>
            <tbody>
              {props.posts.length > 0 ? (
                props.posts.map((post, i) => {
                  return (
                    <tr
                      key={post.bserial}
                      onClick={() => {
                        props.listClick(post.bserial);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <td>{post.rownumber}</td>
                      {Number(post.comment_cnt) > 0 ? (
                        <td>
                          {post.subject}
                          &nbsp;&nbsp;
                          <span
                            style={{
                              color: "#204067",
                              fontSize: ".8rem",
                            }}
                          >
                            <i className="icofont-speech-comments" />
                            &nbsp;
                            {post.comment_cnt}
                          </span>
                        </td>
                      ) : (
                        <td>{post.subject}</td>
                      )}
                      <td className="text-center">
                        {Number(post.file_cnt) > 0 && (
                          <i className="icofont-diskette"></i>
                        )}
                      </td>
                      <td className="text-right">{post.hits}</td>
                      <td>{post.wdate.slice(0, 10)}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="5">
                    {!props.isPosts ? (
                      "결과가 없습니다."
                    ) : (
                      <ContentLoader
                        speed={2}
                        width={600}
                        height={160}
                        viewBox="0 0 600 160"
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                      >
                        <rect
                          x="82"
                          y="3"
                          rx="0"
                          ry="0"
                          width="202"
                          height="22"
                        />
                        <rect
                          x="0"
                          y="3"
                          rx="0"
                          ry="0"
                          width="61"
                          height="22"
                        />
                        <rect
                          x="312"
                          y="3"
                          rx="0"
                          ry="0"
                          width="52"
                          height="22"
                        />
                        <rect
                          x="380"
                          y="3"
                          rx="0"
                          ry="0"
                          width="90"
                          height="22"
                        />
                      </ContentLoader>
                    )}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        );
      case "Gallery": //포토갤러리
        return (
          <table className="table table-hover text-nowrap custom-table">
            <thead>
              <tr>
                <th>번호</th>
                <th className="text-center">썸네일</th>
                <th>제목</th>
                <th className="text-right">조회수</th>
                <th>작성일</th>
              </tr>
            </thead>
            <tbody>
              {props.posts.length > 0 ? (
                props.posts.map((post, i) => {
                  return (
                    <tr
                      key={post.bserial}
                      onClick={() => {
                        props.listClick(post.bserial);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <td>{post.rownumber}</td>
                      <td className="text-center">
                        <img
                          src={`${apiDomain}${post.file_dir}/${post.file_name}`}
                          alt=""
                          className="img-thumbnail img-cover img-fluid"
                          style={{
                            width: "150px",
                            height: "100px",
                            minWidth: "150px",
                            minHeight: "100px",
                            objectFit: "cover",
                          }}
                        />
                      </td>
                      {Number(post.comment_cnt) > 0 ? (
                        <td>
                          {post.subject}
                          &nbsp;&nbsp;
                          <span
                            style={{
                              color: "#204067",
                              fontSize: ".8rem",
                            }}
                          >
                            <i className="icofont-speech-comments" />
                            &nbsp;
                            {post.comment_cnt}
                          </span>
                        </td>
                      ) : (
                        <td>{post.subject}</td>
                      )}
                      <td className="text-right">{post.hits}</td>
                      <td>{post.wdate.slice(0, 10)}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="5">
                    {!props.isPosts ? (
                      "결과가 없습니다."
                    ) : (
                      <ContentLoader
                        speed={2}
                        width={600}
                        height={160}
                        viewBox="0 0 600 160"
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                      >
                        <rect
                          x="82"
                          y="3"
                          rx="0"
                          ry="0"
                          width="202"
                          height="22"
                        />
                        <rect
                          x="0"
                          y="3"
                          rx="0"
                          ry="0"
                          width="61"
                          height="22"
                        />
                        <rect
                          x="312"
                          y="3"
                          rx="0"
                          ry="0"
                          width="52"
                          height="22"
                        />
                        <rect
                          x="380"
                          y="3"
                          rx="0"
                          ry="0"
                          width="90"
                          height="22"
                        />
                      </ContentLoader>
                    )}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        );
      case "News": //자동차정비뉴스
      case "Laws": //자동차관련법규
        return (
          <table className="table table-hover text-nowrap custom-table">
            <thead>
              <tr>
                <th>번호</th>
                <th>제목</th>
                <th>등록일</th>
                {Number(props.userType) < 2 ? <th>삭제</th> : null}
              </tr>
            </thead>
            <tbody>
              {props.posts.length > 0 ? (
                props.posts.map((post, i) => {
                  return (
                    <tr
                      key={post.bserial}
                      onClick={() => {
                        window.open(post.contents, "_blank");
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <td>{post.rownumber}</td>
                      {Number(post.comment_cnt) > 0 ? (
                        <td>
                          {post.subject}
                          &nbsp;&nbsp;
                          <span
                            style={{
                              color: "#204067",
                              fontSize: ".8rem",
                            }}
                          >
                            <i className="icofont-speech-comments" />
                            &nbsp;
                            {post.comment_cnt}
                          </span>
                        </td>
                      ) : (
                        <td>{post.subject}</td>
                      )}

                      <td>{post.wdate.slice(0, 10)}</td>

                      {Number(props.userType) < 2 ? (
                        <td>
                          <button
                            className="btn btn-light btn-custom-sm"
                            type="button"
                            onClick={(e) => {
                              props.fnBoardDelete(post.bserial);
                              e.stopPropagation();
                            }}
                          >
                            <i className="icofont-ui-delete"></i>
                          </button>
                        </td>
                      ) : null}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="3">
                    {!props.isPosts ? (
                      "결과가 없습니다."
                    ) : (
                      <ContentLoader
                        speed={2}
                        width={600}
                        height={160}
                        viewBox="0 0 600 160"
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                      >
                        <rect
                          x="82"
                          y="3"
                          rx="0"
                          ry="0"
                          width="202"
                          height="22"
                        />
                        <rect
                          x="0"
                          y="3"
                          rx="0"
                          ry="0"
                          width="61"
                          height="22"
                        />
                        <rect
                          x="312"
                          y="3"
                          rx="0"
                          ry="0"
                          width="52"
                          height="22"
                        />
                        <rect
                          x="380"
                          y="3"
                          rx="0"
                          ry="0"
                          width="90"
                          height="22"
                        />
                      </ContentLoader>
                    )}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        );
      case "UnionMem": //조합원사 게시판
        return (
          <table className="table table-hover text-nowrap custom-table">
            <thead>
              <tr>
                <th>지역</th>
                <th>구분</th>
                <th>업체명</th>
                <th>대표자명</th>
                <th>대표전화</th>
                <th>주소</th>
              </tr>
            </thead>
            <tbody>
              {props.posts.length > 0 ? (
                props.posts.map((post, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{post.area || ""}</td>
                      <td>{post.comkind || ""}</td>
                      <td>{post.comname || ""}</td>
                      <td>{post.boss || ""}</td>
                      <td>{`${post.tel0}-${post.tel1}-${post.tel2}`}</td>
                      <td>{`${post.address1} ${post.address2}`}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="6">결과가 없습니다.</td>
                </tr>
              )}
            </tbody>
          </table>
        );
      default:
        return null;
    }
  };

  return <div className="col-12">{setList()}</div>;
}

export default List;
